<template>
    <div class="dropdown" v-bind="$attrs">
        <BaseButton 
            id="import" 
            class="btn--filter" 
            v-bind="$attrs" 
            aria-expanded="false" 
            variant="outline" 
            variant-style="secondary"
            data-bs-toggle="dropdown" 
            is-content
            data-bs-auto-close="true" 
            :disabled="disabled" 
        >
            <template #content>
                <span class="mr--5 flex align-items-center">
                    <IconSvg
                        v-if="iconName" 
                        :name="iconName" 
                         
                        width="16px"
                        height="16px"
                    />
                    <span class="ml--5 text--xs">{{ label }}</span>
                </span>
            </template>
        </BaseButton>

        <List id="importList">
            <ListItem 
                v-for="(item, index) in list" 
                :key="index" 
                class="dropdown-item"
                flex
                pointer
                @click="$emit('select', item)"
            >
                <span class="text--xs text--upper">{{ item }}</span>
            </ListItem>
        </List>
    </div>
</template>

<script>
import IconSvg from "../icons/Icon-Svg.vue";
import List from "../lists/List.vue";
import ListItem from "../lists/ListItem.vue";
import BaseButton from "./BaseButton.vue";

export default {
    name: "DropdownButton",

    components: { IconSvg, BaseButton, List, ListItem },
    
    props: {
        label: {
            type: String,
            default: "",
        },
        iconName: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        list: {
            type: Array,
            default: () => ["csv", "json"],
        },
    },

    data() {
        return {
            file: "",
            fileContent: [],
            isParsed: false,
        };
    },
};
</script>

<style lang="scss" scoped>
    .dropdown-menu--tag {
        min-width: 5rem !important;
        font-size: 14px !important;
    }
</style>